import React from 'react';
import '../../../styles/components/date-pill.css';

interface DatePillProps {
  dayOfWeek: string;
  dayNumber: string;
  isToday?: boolean;
  isSelected?: boolean;
  label?: string;
  onClick?: () => void;
  className?: string;
}

const DatePillInner: React.FC<DatePillProps> = ({
  dayOfWeek,
  dayNumber,
  isToday = false,
  isSelected = false,
  label,
  onClick,
  className = ''
}) => {
  const pillClassName = [
    'date-pill',
    isSelected ? 'date-pill--selected' : '',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      className={pillClassName}
      onClick={onClick}
      aria-pressed={isSelected}
      aria-label={`${label || dayOfWeek} ${label ? '' : dayNumber}${isToday ? ' (today)' : ''}${isSelected ? ', selected' : ''}`}
    >
      {label ? (
        <span className="date-pill__label">{label}</span>
      ) : (
        <>
          <span className="date-pill__dow">{dayOfWeek}</span>
          <span className="date-pill__day">{dayNumber}</span>
        </>
      )}
    </button>
  );
};

export const DatePill = React.memo(DatePillInner);
